import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * 合并Tailwind CSS类名的工具函数
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * 获取API基础URL
 */
export function getApiBaseUrl() {
  return import.meta.env.VITE_API_BASE_URL || '/api'
}

/**
 * 获取C4C3 API基础URL
 */
export function getC4C3BaseUrl() {
  return import.meta.env.VITE_C4C3_BASE_URL || '/c4c3'
}

/**
 * 通用API请求函数
 */
export async function fetchApi(
  endpoint: string,
  options: RequestInit = {},
  baseUrl: string = getApiBaseUrl()
) {
  const url = `${baseUrl}/${endpoint}`
  
  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    })
    
    if (!response.ok) {
      throw new Error(`API请求失败: ${response.status}`)
    }
    
    return await response.json()
  } catch (error) {
    console.error(`请求 ${url} 失败:`, error)
    throw error
  }
}

/**
 * C4C3 API请求函数
 */
export async function fetchC4C3Api(
  endpoint: string,
  options: RequestInit = {}
) {
  return fetchApi(endpoint, options, getC4C3BaseUrl())
}

// 生成UUID
export function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c: string) => {
    const randomNum: number = (Math.random() * 16) | 0,
      value: number = c === 'x' ? randomNum : (randomNum & 0x3) | 0x8;
    return value.toString(16);
  });
}

export function getXencioTraceId() {
  return `${generateUUID()}_${new Date().getTime()}`
}